import script from "./ApprovalModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalModal.vue?vue&type=script&setup=true&lang=ts"

import "./ApprovalModal.vue?vue&type=style&index=0&id=031245ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031245ac"]])

export default __exports__